import {
  ReachabilityTest,
  ThirdPartyService,
} from "modules/systemCheck/components/constants";

export const isThirdPartyService = (name: string): name is ThirdPartyService =>
  (name as ThirdPartyService) !== undefined;

export const isReachabilityTest = (name: string): name is ReachabilityTest =>
  (name as ReachabilityTest) !== undefined;
